import React, { useState , useEffect} from 'react';
import './App.css';
import Header from './pages/Header';
import FormularioDireccion from './pages/form_direccion';
import FormularioContacto from './pages/form_contacto';
import FormularioPago from './pages/form_pago';
import SuccesPage from './pages/succes_page'
import FomularioFactura from './pages/form_facturacion';
import DatosFactOk from './pages/datos_fact_ok';


import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


const MainFlow = () => {
    // El estado 'paso' puede ser 1, 2, o 3
    const [paso, setPaso] = useState(1);
    const [datosFormularios, setDatosFormularios] = useState({});
    const [idUrl, setIdUrl] = useState(null);
    const [enviando, setEnviando] = useState(false);
    const [errorEnvio, setErrorEnvio] = useState(null);


    const API_URL = 'https://www.datoscloudfunctions-prd.rotoplas.com/checkout'; 


    // Un useEffect para ver los datos cada vez que cambian
    useEffect(() => {
        console.log('Datos acumulados:', datosFormularios);
    }, [datosFormularios]);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const id = params.get('id');
        if (id) {
            setIdUrl(id);
            
        }
        }, []);

    // Esta función se llama desde el formulario de dirección para avanzar al de contacto
    const handleContinuar = (datos) => {
        // Almacena los nuevos datos en el estado global
        setDatosFormularios(prevDatos => ({ ...prevDatos, ...datos }));
        // Avanza al siguiente paso
        setPaso(prevPaso => prevPaso + 1);

    };

    const onEnviarFinal = async (extraMerge = {}) => {
        try {
            console.log("enviando")
            
            setEnviando(true);
            setErrorEnvio(null);

            const payload = { id: idUrl, ...datosFormularios, ...extraMerge };
            console.log("este es el pyaload")
            console.log(payload)
            console.log("este es el pyaload")
            const resp = await fetch(API_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
            });

            if (!resp.ok) throw new Error(`HTTP ${resp.status}`);

            const data = await resp.json();
            console.log("Respuesta backend:", data);

            // si el backend manda la URL en "message"
            if (data?.message) {
            window.location.href = data.message; // 🔥 redirige a la URL
            }


            // Opcional: navegar a página de éxito o al siguiente paso:
            // setPaso(4); // o el paso que corresponda
        } catch (e) {
            setErrorEnvio(e.message);
        } finally {

            setEnviando(false);
        }
        };

 

    const renderFormulario = () => {
        switch (paso) {
            case 1:
                return <FormularioDireccion onContinuar={handleContinuar} />;
            case 2:
                return <FormularioContacto onContinuar={handleContinuar} onEnviarFinal={onEnviarFinal} enviando={enviando} errorEnvio={errorEnvio} datos={datosFormularios.direccion} />;
            //case 3:
              //  return <FormularioPago onContinuar={handleContinuar} datos={datosFormularios}/>;
            //case 4:
              //  return <SuccesPage onContinuar={handleContinuar} datos={datosFormularios} />
            default:
                return <FormularioDireccion onContinuar={handleContinuar} datos={datosFormularios}/>;
        }
    };

    return (
        <div className="contenedor-formulario">
            {renderFormulario()}
        </div>
    );
}

function App(){
    return (
        <Router>
            <Header />
            <Routes>
                {/* Ruta para el flujo principal de formularios */}
                <Route path="/" element={<MainFlow />} />

                {/* Ruta independiente para el formulario de facturación */}
                <Route path="/form_facturacion" element={<FomularioFactura />} />

                <Route path="/datos_fact_ok" element={<DatosFactOk />} />
            </Routes>
        </Router>
    );
}

export default App;
